import { PickUnion } from '@/models'

export type ScrollBarType = 'horizontal' | 'vertical'

const scrollDirectionMapping: Record<
  ScrollBarType,
  PickUnion<Extract<keyof HTMLElement, string>, 'scrollLeft' | 'scrollTop'>
> = {
  horizontal: 'scrollLeft',
  vertical: 'scrollTop',
}

export const checkForScrollBar = (element: HTMLElement, type: ScrollBarType): boolean => {
  const dir = scrollDirectionMapping[type]
  let res = !!element[dir]
  if (!res) {
    element[dir] = 1
    res = !!element[dir]
    element[dir] = 0
  }
  return res
}
